import React from "react";
import "./Tours.css";

// Sample trips data for India
const trips = [
  {
    id: 1,
    title: "Golden Triangle Tour",
    banner: "/assets/g1.jpg",
    images: ["/assets/g2.jpg", "/assets/g3.jpg"],
    description: "Explore Delhi, Agra, and Jaipur, visiting historic monuments, palaces, and cultural hotspots."
  },
  {
    id: 2,
    title: "Kerala Backwaters",
    banner: "/assets/k1.jpg",
    images: ["/assets/k2.jpg", "/assets/k3.jpg"],
    description: "Relax on serene houseboats, enjoy the lush greenery, and experience traditional Kerala cuisine."
  },
  {
    id: 3,
    title: "Rajasthan Desert Safari",
    banner: "/assets/r1.jpg",
    images: ["/assets/r2.jpg", "/assets/r3.jpg"],
    description: "Experience the royal heritage, desert adventures, camel rides, and vibrant local culture."
  }
];

const Tours = () => {
  return (
    <div className="india-tours-page">
      {trips.map(trip => (
        <div className="india-trip-section" key={trip.id}>
          {/* Trip Banner */}
          <div className="india-trip-banner">
            <img src={trip.banner} alt={trip.title} />
            <div className="india-banner-overlay">
              <h1>{trip.title}</h1>
              <p>{trip.description}</p>
            </div>
          </div>

          {/* Trip Images */}
          <div className="india-trip-gallery">
            {trip.images.map((img, index) => (
              <div className="india-trip-image" key={index}>
                <img src={img} alt={`${trip.title} ${index + 1}`} />
              </div>
            ))}
          </div>

          {/* Trip Details */}
          <div className="india-trip-description">
            <p>{trip.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Tours;
